import { SpeedquizEntity } from '../Types/admin/speedquiz';
import { ObjectType } from '../Types/base';
import { get, getQSFromObject } from './common';

const speedquizEndpoint = 'api/speedquiz';

export async function getSpeedquizInstancesForLoggedInUser(
	objectType?: ObjectType,
	objectId?: number
): Promise<SpeedquizEntity[]> {
	const url = `${speedquizEndpoint}/GetSpeedquizInstancesForLoggedInUser?${getQSFromObject({ objectType, objectId })}`;
	const result = await get<SpeedquizEntity[]>(url);
	return result || [];
}
